export enum EndpointType{
  ENTERPRISE = "ENTERPRISE",
  SERVICEPROVIDER = "SERVICEPROVIDER"
}


// WEBPACK FOOTER //
// ./src/app/shared/model/endpoint-type.ts